<ul>
    <li *ngFor="let option of options" [class.selected]="option.value == ngModel">
        <button (click)="onClickOption(option)">
            {{ option.name }}
        </button>
    </li>
</ul>
